import { render, staticRenderFns } from "./EmptyScreen.vue?vue&type=template&id=c9127056&scoped=true"
import script from "./EmptyScreen.vue?vue&type=script&lang=js"
export * from "./EmptyScreen.vue?vue&type=script&lang=js"
import style0 from "./EmptyScreen.vue?vue&type=style&index=0&id=c9127056&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9127056",
  null
  
)

export default component.exports